module.exports = __webpack_public_path__ + "static/media/appstore_en.2928664f.svg";